import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
// material-ui
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import SyncIcon from '@mui/icons-material/Sync';
import useMediaQuery from '@mui/material/useMediaQuery';
import { collection, doc, getDocs, onSnapshot, setDoc, query, where } from 'firebase/firestore';
import { setDeviceList, setSelectedDevice, showAppAlert, setAppUser } from 'store/reducers/appreducer';
import { AuthContext } from '../auth/auth-context';
import { db } from '../services/firebase';
import { CircularProgress } from '../../node_modules/@mui/material/index';
import SelectDeviceDialog from './SelectDeviceDialog';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';

import { getUserDevices, getUserProfile } from 'services/apiService';
import useToken from 'services/useToken';

const SwitchDevice = () => {
  const { user } = useContext(AuthContext);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [allDevices, setAllDevices] = useState([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState('');
  const [loading, setLoading] = useState(false);
  const [syncLoading, setSyncLoading] = useState(false);
  const [openSelectDeviceDialog, setOpenSelectDeviceDialog] = useState(false);
  const [showDeviceSync, setShowDeviceSync] = useState(true);
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
  const { selectedDevice } = useSelector((state) => state.appreducer);
  const { token, setToken } = useToken();

  const handleSelectDeviceDialogOpen = () => {
    // getDevicesList();
    setOpenSelectDeviceDialog(true);
  };
  const handleSelectDeviceDialogClose = () => {
    setOpenSelectDeviceDialog(false);
  };

  const onDeviceSelect = (deviceId) => {
    setDevice(deviceId);
    setOpenSelectDeviceDialog(false);
  };

  /* const onSwitchDevice = (event) => {
    const selectedDeviceId = event.target.value;
    console.log({ selectedDeviceId });
    setDevice(selectedDeviceId);
  }; */

  const setDevice = (deviceId) => {
    dispatch(setSelectedDevice({ selectedDevice: deviceId }));
    setSelectedDeviceId(deviceId);
  };

  const hadleDeviceSyncClick = () => {
    const sync = async () => {
      setSyncLoading(true);
      const tasksRef = doc(db, 'tasks', selectedDeviceId);
      await setDoc(tasksRef, {
        device_id: selectedDeviceId,
        type: 'sync_config',
        payload: {}
      })
        .then((docRef) => {
          dispatch(showAppAlert({ show: true, alertType: 'success', alertMessage: 'Sync Device settigs request Successful!' }));
        })
        .catch((error) => {
          console.log(error);
          dispatch(showAppAlert({ show: true, alertType: 'error', alertMessage: error?.message || 'Error: Sync Device settigs request!' }));
        });
      setSyncLoading(false);
    };
    sync();
  };

  const getDevicesList = async () => {
    console.log('getdeviceList');
    const devicesRes = await getUserDevices(token).then((response) => {
      if (response.error) {
        return;
      }
      const responseData = response?.data || [];
      const devicesData = responseData?.map((d) => {
        return {
          id: d.IMEI,
          IMEI: d.IMEI,
          model: d.model,
          name: d.device_name || '-'
        };
      });
      // console.log('deviceData', devicesData);
      return devicesData;
    });
    // console.log({devicesRes});
    if (devicesRes && devicesRes.length > 0) {
      setAllDevices(devicesRes || []);
      setDevice(devicesRes[0].IMEI);
    } else {
      setAllDevices([]);
      setDevice('');
    }
  };

  useEffect(() => {
    dispatch(setDeviceList({ deviceList: allDevices }));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allDevices]);

  useEffect(() => {
    // console.log('switchDEvice', { selectedDevice });
    setDevice(selectedDevice);
  }, [selectedDevice]);

  useEffect(() => {
    if (!selectedDeviceId && !openSelectDeviceDialog && allDevices.length > 0) {
      setOpenSelectDeviceDialog(true);
    }
  }, [selectedDeviceId, openSelectDeviceDialog, allDevices]);

  // active menu item on page load
  useEffect(() => {
    if (pathname.includes('/settings')) {
      setShowDeviceSync(true);
    } else {
      setShowDeviceSync(false);
    }
  }, [pathname]);

  useEffect(() => {
    const getUserData = async () => {
      // Check if this is a partner session
      const isPartnerSession = sessionStorage.getItem('is_partner_session');
      const userDataStr = sessionStorage.getItem('user');

      if (isPartnerSession === 'true' && userDataStr) {
        // Partner session: Get user data from sessionStorage (already validated by deeplink)
        try {
          const partnerUser = JSON.parse(userDataStr);
          dispatch(setAppUser({ appUser: partnerUser }));
        } catch (e) {
          console.error('Failed to parse partner user data from sessionStorage:', e);
        }
      } else {
        // Regular session: Get user data from API
        const userRes = await getUserProfile(token).then((response) => {
          return response;
        });
        if (!userRes.error) {
          dispatch(setAppUser({ appUser: userRes.data }));
        }
      }
    };

    const getDevices = async () => {
      const devicesRes = await getUserDevices(token).then((response) => {
        if (response.error) {
          return;
        }
        // console.log(response)
        const responseData = response?.data || [];
        const devicesData = responseData?.map((d) => {
          return {
            id: d.IMEI,
            IMEI: d.IMEI,
            model: d.model,
            name: d.device_name || '-'
          };
        });
        return devicesData;
      });
      // console.log('deviceres',{ devicesRes });
      if (devicesRes && devicesRes.length > 0) {
        setAllDevices(devicesRes || []);
        setDevice(devicesRes[0].IMEI);
      } else {
        setAllDevices([]);
        setDevice('');
      }
    };
    getUserData();
    getDevices();
  }, []);

  if (!allDevices.length) {
    return <></>;
  }
  return (
    <>
      {loading ? (
        <Skeleton variant="rectangular" animation="wave" minWidth={150} height={37} />
      ) : (
        <Box>
          {/* <FormControl sx={{ mr: 1, minWidth: 150 }} size="small">
          <InputLabel id="switch-device-autowidth-label">Select Device</InputLabel>
          <Select labelId="switch-device-autowidth-label" id="switch-device-autowidth" value={selectedDeviceId} onChange={onSwitchDevice}>
            {allDevices &&
              allDevices.map((d, i) => (
                <MenuItem value={d.id} key={i}>
                  {d?.name || d.id}
                </MenuItem>
              ))}
          </Select>
        </FormControl> */}

          {/* Show the currently selected device */}
          <Box sx={{ display: 'inline-block', mr: 2, verticalAlign: 'middle' }}>
            <Typography variant="body1" color="textSecondary">
              Device:&nbsp;
              <span style={{ fontWeight: 500 }}>{`${
                allDevices.find((d) => d.id === selectedDeviceId)?.name || ''
              } | ${selectedDeviceId}`}</span>
            </Typography>
          </Box>

          <Button
            onClick={handleSelectDeviceDialogOpen}
            color={'primary'}
            disabled={syncLoading}
            variant={'outlined'}
            startIcon={<DevicesOtherIcon />}
            sx={{ mr: 1 }}
          >
            {!matchDownSM && 'Select Device'}
          </Button>

          {showDeviceSync && (
            <Button
              onClick={hadleDeviceSyncClick}
              color={'primary'}
              disabled={syncLoading}
              variant={'outlined'}
              startIcon={syncLoading ? <CircularProgress size={20} /> : <SyncIcon />}
              sx={{ mr: 1 }}
            >
              {!matchDownSM && 'Sync Device Settings'}
            </Button>
          )}
          {openSelectDeviceDialog && (
            <SelectDeviceDialog
              open={openSelectDeviceDialog}
              handleClose={handleSelectDeviceDialogClose}
              onDeviceSelect={onDeviceSelect}
            ></SelectDeviceDialog>
          )}
        </Box>
      )}
    </>
  );
};

export default SwitchDevice;
